import { connect } from 'react-redux'
import component from './component'
import {
  MODAL,
  BOOKING,
  HOLIDAY
} from '../../reduxs'

function mapStateToProps ({
  accountReducer,
  modalReducer,
  loaderReducer,
  holidayReducer
}) {
  return {
    permission: accountReducer.permission,
    language: accountReducer.language,
    username: accountReducer.user.username,
    minuteStep: accountReducer.user.minuteStep,
    startOperatingTime: accountReducer.user.startOperatingTime,
    endOperatingTime: accountReducer.user.endOperatingTime,
    dataUser: accountReducer.user,
    modalStatus: modalReducer.status,
    loader: loaderReducer.isDisplay,
    listHoliday: holidayReducer.listHoliday,
    isOpenCrashMeetingModal: modalReducer.isOpenCrashMeetingModal,
    companyTokenType: accountReducer.profile.companyTokenType
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModalStatus: (div) => dispatch(MODAL.action.openModalStatus(div)),
    closeModalStatus: () => dispatch(MODAL.action.closeModalStatus()),

    createIssue: (param, func) => dispatch(BOOKING.action.createIssue(param, func)),
    endMeeting: (param, func) => dispatch(BOOKING.action.endMeeting(param, func)),

    getListHoliday: (param) => dispatch(HOLIDAY.action.getListHoliday(param)),
    onCloseCrashMeetingModal: (param) => dispatch(MODAL.action.closeCrashMeetingModal(param)),
    openCrashMeetingModal: () => dispatch(MODAL.action.openCrashMeetingModal()),
    updateBooking: (params) => dispatch(BOOKING.action.updateBooking(params)),
    createBooking: (params, trackingSaveButton) => dispatch(BOOKING.action.createBooking(params, trackingSaveButton))
  }
}

export default connect(
  (state, ownProps) => mapStateToProps(state, ownProps, mapDispatchToProps),
  (dispatch) => mapDispatchToProps(dispatch)
)(component)
